import React, { useEffect, useState } from "react";

export const Navigation = ({ setOpenModal, language, translations }) => {
  const [currentFlag, setCurrentFlag] = useState("./img/usa.png");

  useEffect(() => {
    const flagMap = {
      fr: "./img/france.png",
      en: "./img/usa.png",
      es: "./img/spain.png",
      pt: "./img/brazil.png",
      de: "./img/germany.png",
      zh: "./img/china.png",
      it: "./img/italy.png",
      ja: "./img/japan.png",
      ru: "./img/russia.png",
      nl: "./img/netherlands.png",
    };
    setCurrentFlag(flagMap[language] || flagMap.en || "./img/usa.png");
  }, [language]);

  return (
    <nav id="menu" className="navbar navbar-default">
      <div className="container ">
        <div className="navbar-header">
          <button
            type="button"
            className="navbar-toggle collapsed"
            data-toggle="collapse"
            data-target="#bs-example-navbar-collapse-1"
          >
            {" "}
            <span className="sr-only">Toggle navigation</span>{" "}
            <span className="icon-bar"></span>{" "}
            <span className="icon-bar"></span>{" "}
            <span className="icon-bar"></span>{" "}
          </button>
          <a className="navbar-brand page-scroll" href="#page-top">
            COMEXDEAL4TRADE
          </a>{" "}
        </div>
        <div
          className="collapse navbar-collapse "
          id="bs-example-navbar-collapse-1"
        >
          <ul className="nav navbar-nav navbar-right navbar-blur">
            {translations &&
              translations.Navigation &&
              Object.keys(translations.Navigation).map((key) => {
                const item = translations.Navigation[key];
                return (
                  <li key={key}>
                    <a href={item.href} className="page-scroll">
                      {item.label}
                    </a>
                  </li>
                );
              })}
            <li>
              <a
                href="#"
                className="btn_idiomas"
                role="button"
                onClick={() => setOpenModal(true)}
              >
                <img
                  src={currentFlag}
                  alt={`${translations?.navigation?.flag || "Flag"}`}
                  style={{ width: "30px", height: "23px", marginRight: "8px" }}
                />
              </a>
            </li>
            <li>
              <a href="#" className="btn mylogin" role="button">
                {translations?.selection?.client ?? "Client Area"}
              </a>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  );
};
